import { createAction } from 'utils/redux'

export const receivePlaybook = (playbook) =>
  createAction({
    type: 'RECEIVE_PLAYBOOK',
    playbook,
  })

export const receivePlaybookName = (name) =>
  createAction({
    type: 'RECEIVE_PLAYBOOK_NAME',
    name,
  })

export const receivePlaybookStatus = (status) =>
  createAction({
    type: 'RECEIVE_PLAYBOOK_STATUS',
    status,
  })
